import { inject } from 'vue'
import type { InjectionKey } from 'vue'
import { useConfirm } from 'primevue/useconfirm'

export type PromptTextFn = (opts: {
  title: string
  message?: string
  placeholder?: string
}) => Promise<string | null>

export const PromptDialogKey: InjectionKey<PromptTextFn> = Symbol('PromptDialog')

/**
 * Show a confirmation dialog (PrimeVue ConfirmDialog) or a prompt dialog with textarea.
 */
export function useConfirmDialog() {
  const confirmService = useConfirm()
  const openPrompt = inject(PromptDialogKey, null)

  function confirm(title: string, message?: string): Promise<boolean> {
    return new Promise((resolve) => {
      confirmService.require({
        header: title,
        message: message || '',
        rejectProps: {
          label: 'Cancel',
          severity: 'secondary',
        },
        acceptProps: {
          label: 'Confirm',
        },
        accept: () => resolve(true),
        reject: () => resolve(false),
      })
    })
  }

  async function promptText(
    title: string,
    message?: string,
    placeholder?: string,
  ): Promise<string | null> {
    if (!openPrompt) {
      console.warn('PromptDialog not provided. Make sure PromptDialog is mounted in App.vue.')
      return null
    }
    return openPrompt({ title, message, placeholder })
  }

  return { confirm, promptText }
}
